/**
   * @ngdoc service
   * @name adjust.service:Highlight
   *
   * @description
   * Hightlight service which takes care of the sound
   *
   */
function Highlight($http) {
  'ngInject';
  var _ctx;
  var _file;

  return {
    init: init,
    play: play,
    stop: stop
  };

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.service:Highlight
   *
   * @description
   * Preload the beep sound
   *
   */
  function init() {

    if (!_ctx) {
      if (typeof AudioContext !== 'undefined') {
        _ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        _ctx = new webkitAudioContext();
      }
    }

    if (!_ctx) { return; }

    $http.get('/assets/sounds/ping.mp3', {responseType: 'arraybuffer'})
      .success(function(data) {
        _ctx.decodeAudioData(data, function(buffer) {
          _file = buffer;
        });
      });

  }

  /**
   * @ngdoc method
   * @name play
   * @methodOf adjust.service:Highlight
   *
   * @description
   * Play the beep sound
   *
   */
  function play() {

    if (!_file || !_ctx) { return; }

    var src = _ctx.createBufferSource();
    var gainNode = _ctx.createGain();

    src.buffer = _file;
    src.connect(gainNode);

    gainNode.connect(_ctx.destination);
    gainNode.gain.value = 1;

    src.start(0);

    _file.src = src;

  }

  /**
   * @ngdoc method
   * @name stop
   * @methodOf adjust.service:Highlight
   *
   * @description
   * Stop the beep sound
   *
   */
  function stop() {

    if (!_file || !_ctx || _file && !_file.src) { return; }

    _file.src.stop(0);

  }
}

/**
   * @ngdoc directive
   * @name adjust.directive:highlight
   * @scope
   * @restrict A
   *
   * @description
   * Directive which pin-points the action that user needs to perform in order to close the sidebar
   * For example create app, once user start entering data he needs to explicitly hit cancel in order to close the sidebar
   * Parent directive is {@link adjust.directive:rightSidebar rightSidebar}
   *
   */
function highlight($timeout, Helper, Highlight) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    require: '?^rightSidebar',
    link: function(scope, element, attrs, rightSidebarController) {

      var _tid;

      element.addClass('dismiss-highlight');
      Highlight.init();

      if (rightSidebarController && angular.isFunction(rightSidebarController.onDismiss)) {
        rightSidebarController.onDismiss(_handleDismiss);
      }

      scope.$on('highlight:on', _handleDismiss);
      element.on('$destroy', _handleDestroy);

      /**
       * @ngdoc method
       * @name _handleDismiss
       * @methodOf adjust.directive:highlight
       *
       * @description
       * Initiate highlight when trying to dismiss sidebar
       *
       * @private
       */
      function _handleDismiss() {

        Highlight.play();
        Helper.destroyTid(_tid);

        element.addClass('dismiss-highlight-show');

        _tid = $timeout(function() {
          element.removeClass('dismiss-highlight-show');
        }, 500);

      }

      /**
       * @ngdoc method
       * @name _handleDestroy
       * @methodOf adjust.directive:highlight
       *
       * @description
       * Destroy timeout on element destroy
       *
       * @private
       */
      function _handleDestroy() {

        Highlight.stop();
        Helper.destroyTid(_tid);

      }

    }
  };
}


export { Highlight, highlight };
